import { useEffect, useState } from "react";
import { fetchData } from "../function/util";
import ProductList from "../components/ProductList";
const Men=()=>{
    const [data, setData] = useState([]);

    useEffect(()=>{
        fetchData("products", {category:"men"})
        .then((result) => {
            setData(result);
            // if(result.lastDoc)localStorage.setItem("inventorylastDoc", JSON.stringify(result.lastDoc));
            // setTotalCount(result.totalCount);
        })
        .catch((error) => {
            console.error('Error fetching data:', error)
        })
    }, []);
    return (
        <div className="main-content">
            <ProductList data={data.products} />
        </div>
    )
}
export default Men;